export default __webpack_public_path__ + "static/media/blog.b0a015e5.png";